import React from 'react';
import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';

export interface CheckboxProps {
  /** Label shown next to the box */
  label: string;
  /** Current state */
  checked: boolean;
  /** Change handler (receives the new boolean) */
  onChange: (checked: boolean) => void;
  /** Optional error flag + helper text */
  error?: boolean;
  helperText?: string;
  /** Pass-through props (id, name, disabled, …) */
  [x: string]: any;
}

/**
 * Design-system checkbox wrapper.
 * Keeps MUI implementation details out of feature code.
 */
const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  error = false,
  helperText,
  ...rest
}) => (
  <div>
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          {...rest}
        />
      }
      label={label}
    />
    {error && helperText && <FormHelperText error>{helperText}</FormHelperText>}
  </div>
);

export default Checkbox;
